export interface PaymentDetails {
  payment_type: PaymentType;
  third_party_channel_url: string; // 若是积分支付等三方支付，增加跳转url
}

// PaymentType 支付类型
enum PaymentType {
  CASH = 0, // 现金支付
  POINTS = 1, // 积分支付
}

enum CouponType {
  COUPON_TYPE_NORMAL = 0, // 普通通用抵扣券
  COUPON_TYPE_ACTIVITY = 1, // 活动运营折扣券
}

export enum EnquityType {
  ENQUITY_TYPE_BASE = 0, // 基础权益卡
  ENQUITY_TYPE_EXTRA = 1, // 附加权益卡
}

// 优惠券信息
export interface Coupon {
  name: string;  // 外显名字
  price: number; // 优惠券所能抵扣的价格 单位：分
  desc: string;  // 描述说明
  endTs: number; // 有效期的结束时间
  groupId: string; // midas 营销活动 group_id
  goodsId: string; // 飞鱼物品ID
  couponType: CouponType; // 优惠券类型
  relatedOfferId: string[]; // 优惠券所属的offerid
  relatedProductId: string[]; // 关联的productid
}

export interface CrossedText {
  text: string; // 划线文案
  isCrossed: boolean; // 是否划线
}


// 商品信息
export interface Card {
  name: string;  // 外显名字
  price: number; // 基础价格（单位：分），前端根据用户选择的优化券进一步扣减出预计价格；
  desc: string;  // 描述说明
  tag: string;   // 右上角红色角标内容
  coupons: Coupon[]; // 能使用的优惠券
  originalPrice: string;   // 划线价格（单位：分），仅用于展示；可能为空；
  goodsId: string; // 飞鱼物品ID
  crossedText: CrossedText; // 划线文案
  // 以下字段不需要外显，用于支付时请求midas
  offerId: string;
  zoneId: string;
  productId: string;
  serviceCode: string;       // 业务代码
  serviceName: string;       // 业务名字
  autopayProductid: string;  // 非自动续费物品时对应的自动续费物品
  autopayType: number;       // 自动续费类型，0-非自动/停止续费，1-自动续费
  cardType: number;         //  会员类型，0-非会员，1-月会员，2-季会员，3-年会员，4-周会员，详见 CardType
  orderWeight: number;       // 排序权重（权重越大，展示顺序越靠前）
  // h5新增字段
  h5ContinueMonthExtra: string; // 用于小月卡自动续费能力
  // 支付类型
  paymentDetails: PaymentDetails;
  // 权益类型
  enquityType: EnquityType; // 权益类型
  extraCards: Card[]; // 权益加量卡，例如工具云收藏加量包
  extraCardIds: string[]; // 权益加量卡的id列表

  isItem: boolean; // 前端用来判断是不是单次购买
};

export interface PrivilegedCard {
  name: string; // 特权卡名
  status: number; // 状态：0-未开通，1-已开通，2-已过期
  type: number; // 会员类型 0-非会员，1-月会员，2-年会员
  endTime: number; // 到期时间

  autopayType: number; // 自动续费类型，0-否，1-自动包月，2-自动包季，3-自动包年\
  startTime: number;   // 开始时间
  isNewUser: boolean;
  loaded: boolean;

  enquityType?: EnquityType;
}

export const defaultPrivilegeCard = {
  name: '',
  status: 0,
  type: 0,
  endTime: 0,
  autopayType: 0,
  startTime: 0,
  isNewUser: false,
  loaded: false,
};

export interface PrivilegedItem {
  name: string;        // 特权道具名字
  balance: string;     // 当前剩余次数
  save_sum: string;    // 历史总购买次数
}

export enum PayType {
  QQ = 'qq',
  WECHAT = 'wx',
}

export enum PrivilegedStatus {
  NONE = 0, // 未开通
  VIP = 1,
  EXPIRED = 2,
}

export enum PrivilegedAutoType {
  NO = 0,
  AUTO = 1,
}

export const CARD_TYPE_NAME = {
  0: '',
  1: '月',
  2: '季',
  3: '年',
  4: '周',
};

export const CARD_TYPE_DAY = {
  0: 1,
  1: 30,
  2: 90,
  3: 365,
  4: 7,
};

// 道具类信息
export interface Item {
  name: string;   // 外显名字
  price: number;// 价格（单位：分），用于展示
  num: number; // 数量/资格次数，对应终端支付 midas 参数 saveValue（游戏币数量）
  desc: string;  // 描述说明
  tag: string;  // 右上角红色角标内容
  // repeated Coupon coupons = 5; // 能使用的优惠券
  original_price: number;  // 划线价格（单位：分），仅用于展示；
  goods_id: string; // 飞鱼物品ID
  // 以下字段不需要外显，用于支付时请求midas
  offer_id: string;       // midas offerid
  zone_id: string;        // midas zoneid
  product_id: string;     // midas iap productid
  service_code: string;   // 业务代码
  // 以下字段后台使用，缓存数据
  platform: number;
  login_type: number;
  filter_type: number;
  pointid: string;
}
